<template>
  <div>
    <div>
      <el-form :model="form" ref="form" label-width="120px" :hide-required-asterisk="true">
        <div @keyup.enter.stop="save()">
          <el-form-item label="考试名称" prop="batchName" :rules="[$validate.string(30)]">
            <el-select v-model="form.batchId" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
              <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', false)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: {},
      batchList: []
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (!this.form.batchId) {
      this.form.batchId = this.batchList[0].batchId
    }
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      if (this.row) {
        let info = JSON.parse(JSON.stringify(this.row))
        this.form = info
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        let info
        if (this.form.batchId) {
          let param = {
            batchId: this.form.batchId,
            examId: this.row.examId
          }
          info = await this.$HTTP.ApiExamOnline.changeExamBatch(param)
        }
        this.$message({ type: 'success', message: '操作成功' })
        this.$emit('close', true)
      }
    }
  }
}
</script>
